import { createContext, ReactNode, useContext, useEffect } from 'react'

type SetFooterAction = (node: ReactNode) => void

// null = no hay footer compartido donde registrar la acción (la card se está renderizando
// suelta, fuera del flujo por pasos). Ver useStepFooterAction.
export const StepFooterActionContext = createContext<SetFooterAction | null>(null)

/* Registra el botón de acción principal del paso actual en el footer compartido del flujo
   (junto a Rechazar Tradein / demás acciones administrativas), en vez de renderizarlo dentro
   de la tarjeta del paso. `deps` son los valores reactivos de los que depende el botón (loading,
   disabled, etc.) — el nodo se vuelve a registrar solo cuando alguno cambia, y se limpia al
   desmontar o cuando el paso deja de aplicar.
 *
 * Devuelve el nodo cuando NO hay un footer donde registrarlo —el caso de la página de detalle
 * clásica, que muestra las cards sueltas en un grid— para que la card lo renderice inline como
 * siempre. Si hay footer devuelve null, porque el botón ya se dibuja allá. */
export const useStepFooterAction = (node: ReactNode, deps: unknown[]): ReactNode => {
  const setFooterAction = useContext(StepFooterActionContext)

  useEffect(() => {
    if (setFooterAction === null) return
    setFooterAction(node)
    return () => setFooterAction(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  return setFooterAction === null ? node : null
}
